import styled from 'styled-components';

export const SChat = styled.section`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;

export const SRepliesLoader = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

export const SChatContainer = styled.div<{ $topPadding?: boolean }>`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: ${({ $topPadding }) => ($topPadding ? '3rem' : '0')};

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const SScrollDownBtw = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 80px;
  right: 20px;
  cursor: pointer;
  z-index: 5;
  background: none;
  border: none;
  padding: 0;
`;

export const SFilesLoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  padding: 0 1rem 1.125rem;
  min-height: 50px;
`;

export const SStickyInstructionsBar = styled.div<{ $visible: boolean }>`
  transition: opacity 0.2s ease;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
`;
